<template>
  <div class="justify-content-center mb-5" id="esgContainer">
    <div class="row justify-content-center align-items-center mt-5" style="color:white">
      <div style="margin-right:5px">L'impact sur la planète de votre</div>
      <select class="mf_select_black" v-model="comparison">
        <option value="null" disabled>Enveloppe</option>
        <option v-for="(comparison, index) in comparisons_platforms" :key="index" :value="comparison">
          {{ comparison.platform_contract_name }}
        </option>
      </select>
      <div style="margin-left:5px">analysé</div>
    </div>

    <div class="row justify-content-center mt-5">
      <div class="row" style="font: normal normal bold 1.3em Segoe UI;color: #FFFFFF;">
        Les indicateurs énergétiques de votre portefeuille :
      </div>
      <div class="row justify-content-center mt-4">
        <div class="col-12 col-sm-4">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">
              Scope 1
              <span v-b-modal="'my_modal_scope1' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scope1' + this.uid" centered hide-footer title="Scope 1">
                <p class="my-4">Le Scope 1 comprend les émissions de gaz à effet de serre directement liées à la fabrication des produits. Par exemple, si la fabrication d'un produit nécessite l'utilisation de pétrole, la combustion de carburant, ou si la production du produit génère des émissions de CO2 ou de méthane, toutes ces émissions sont incluses dans le scope 1. C'est ce qu'on appelle les émissions directes.</p>
              </b-modal>
            </div>
            <div class="nb">{{ formatEuros(comparison.contract_esg_carbon_scope1_ponderated) }}</div>
            <div class="last">Tonnes Co2 / ans</div>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">
              Scope 2
              <span v-b-modal="'my_modal_scope2' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scope2' + this.uid" centered hide-footer title="Scope 2">
                <p class="my-4">
                  Le Scope 2 comprend les émissions de gaz à effet de serre liées à la consommation d'énergie nécessaire à la fabrication des produits. Par exemple, pour fabriquer un produit, vous devez généralement consommer de l'électricité pour alimenter l'usine où le produit est conçu. Cette consommation électrique en elle-même ne génère pas de gaz à effet de serre. Mais la production d'électricité émet des gaz à effet de serre. Toutes ces émissions liées à la consommation d'énergie
                  secondaire sont incluses dans le périmètre. On parle d'émissions indirectes liées à la consommation d'énergie.
                </p>
              </b-modal>
            </div>
            <div class="nb">{{ formatEuros(comparison.contract_esg_carbon_scope2_ponderated) }}</div>
            <div class="last">Tonnes Co2 / ans</div>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">
              Total
            </div>
            <div class="nb">{{ formatEuros(comparison.contract_esg_carbon_overall_ponderated) }}</div>
            <div class="last">Tonnes Co2 / ans</div>
          </div>
        </div>
        <!--
        <div class="col-12 col-sm-4">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">
              Scope 3
              <span v-b-modal="'my_modal_scope3' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scope3' + this.uid" centered hide-footer title="Scope 3">
                <p class="my-4">
                  Le Scope 3 comprend toutes les autres émissions de gaz à effet de serre. Ces émissions ne sont pas directement liées à la fabrication du produit, mais sont liées à d'autres étapes du cycle de vie du produit (approvisionnement, transport, utilisation, fin de cycle de vie...cycle de vie...) . Par exemple, pour fabriquer un produit, vous avez besoin de matières premières. L'extraction, la transformation et le transport de ces matières premières vers les usines de production
                  émettent des gaz à effet de serre. De même, la fin de vie ou le recyclage du produit émettra également des gaz à effet de serre. Ces émissions indirectes liées au cycle de vie du produit sont enregistrées dans le Scope 3. On les appelle autres émissions indirectes.
                </p>
              </b-modal>
            </div>
            <div class="nb">{{ formatEuros(comparison.contract_esg_carbon_scope3) }}</div>
            <div class="last">Tonnes Co2 / ans</div>
          </div>
        </div>
        -->
      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-12 col-sm-6">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">Score Co2 de votre portefeuille :</div>
            <div class="nb">{{ formatEuros(comparison.contract_esg_carbon_revenues) }}</div>
            <div class="last">Tonnes Co2 / Millions d'euros de CA</div>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">Le coût carbone réel de votre portefeuille est de :</div>
            <div class="nb"> <span style="color: #9561E2;"> Coming soon </span> </div>
            <!-- Uncomment when immplemented
            <div class="nb">coming soon Tonnes de C02 par an</div>
            <div class="last">Soit <span style="color: #9561E2;">coming soon</span> aller retour Paris - New York</div>
            -->
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-5" style="color: #FFFFFF;">
      <div style="font: normal normal bold 1.3em Segoe UI;">Découvrez le détail du coût carbone de votre portefeuille</div>
    </div>

    <div class="row justify-content-center mt-4">
      <table id="ltf-table">
        <colgroup>
          <col style="width: 30%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 20%;" />
        </colgroup>
        <thead>
          <tr>
            <th style="text-align: left;">Titre</th>
            <th>Poids (%)</th>
            <th>Scope 1 Tonnes Co2 / ans</th>
            <th>Scope 2 Tonnes Co2 / ans</th>
            <!--
            <th>
              <span v-b-modal="'my_modal_scoreEnt' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scoreEnt' + this.uid" centered hide-footer title="Chiffres d'affaires">
                <p class="my-4">
                  Le Scope 3 comprend toutes les autres émissions de gaz à effet de serre. Ces émissions ne sont pas directement liées à la fabrication du produit, mais sont liées à d'autres étapes du cycle de vie du produit (approvisionnement, transport, utilisation, fin de cycle de vie...cycle de vie...) . Par exemple, pour fabriquer un produit, vous avez besoin de matières premières. L'extraction, la transformation et le transport de ces matières premières vers les usines de production
                  émettent des gaz à effet de serre. De même, la fin de vie ou le recyclage du produit émettra également des gaz à effet de serre. Ces émissions indirectes liées au cycle de vie du produit sont enregistrées dans le Scope 3. On les appelle autres émissions indirectes.
                </p>
              </b-modal>
              Scope 3 Tonnes Co2 / ans
            </th>
            -->
            <th> Total Tonnes Co2 / ans</th>
            <th>
              <span v-b-modal="'my_score_co2' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_score_co2' + this.uid" centered hide-footer title="Score CO2 coût">
                <p class="my-4">
                  Ce score témoigne de l'impact de la position sur la planète. Son unité est la Tonne de Co2 / Milliards d'euros de chiffre d'affaire. Il correspond à la dépense énergétique de l'entreprise en fonction de son chiffre d'affaire (moyenne pondérée des entreprises dans le cas d'un fonds ou d'un ETF). Plus ce score est élevé plus la position a un impact négatif sur la planète en terme de rejet de C02. Ce score permet de comparer des entreprises de tailles différentes
                </p>
              </b-modal>
              Score Co2
            </th>
            <th>
              <span v-b-modal="'my_modal_scoreEnt' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scoreEnt' + this.uid" centered hide-footer title="Mon coût carbone">
                <p class="my-4">
                  Cet indicateur correspond au coût carbone réel de vos investissements. Il est calculé à partir de votre pourcentage de détention du capital des entreprises sur lesquels vous investissez. Par exemple si vous détenez 1% du capital d'une entreprise avec un coût carbone (scope 3) de 1 000 Tonnes de C02 par an, vous êtes alors responsable de la dépense énergétique de 10 Tonnes de C02 par an
                </p>
              </b-modal>
              Mon coût carbone</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(alternative, i) in comparison.securities" :key="i">
            <div v-if="alternative.hasOwnProperty('security')" style="display: contents;" id="random">
              <td style="text-align: left;">
                <div>{{ alternative.security.name }}</div>
                <div>ISIN : {{ alternative.security.isin }}</div>
              </td>
              <td>{{ Math.round(alternative.weight * 100) }}%</td>
              <td>
                {{ formatEuros(alternative.scope1) }}
              </td>
              <td>
                {{ formatEuros(alternative.scope2) }}
              </td>
              <!--
              <td>
                {{ formatEuros(alternative.scope3) }}
              </td>
              -->
              <td>
                {{ formatEuros(alternative.total) }}
              </td>
              <td>
                {{ formatEuros(Math.round(alternative.revenues)) }}
              </td>
              <td style="color:#9561E2">Coming Soon</td>
            </div>
          </tr>
          <tr>
            <div style="display: contents;" id="random">
              <td style="text-align: left;">
                Total
              </td>
              <td style="text-align: left;"></td>
              <td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_scope1)) }}</td>
              <td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_scope2)) }}</td>
              <!--<td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_scope3)) }}</td>-->
              <td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_overall)) }}</td>
              <td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_revenues)) }}</td>
              <td style="color:#9561E2">Coming Soon</td>
            </div>
          </tr>
           <tr>
            <div style="display: contents;" id="random">
              <td style="text-align: left;">
                Total pondéré
              </td>
              <td style="text-align: left;"></td>
              <td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_scope1_ponderated)) }}</td>
              <td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_scope2_ponderated)) }}</td>
              <!--<td>{{ formatEuros(Math.round(comparison.alt_contract_esg_carbon_scope3_ponderated)) }}</td>-->
              <td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_overall_ponderated)) }}</td>
              <td>{{ formatEuros(Math.round(comparison.contract_esg_carbon_revenues_ponderated)) }}</td>
              <td style="color:#9561E2">Coming Soon</td>
            </div>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row justify-content-center mt-5" style="color: #FFFFFF;">
      <div style="font: normal normal bold 1.3em Segoe UI;">Votre portefeuille décarbonné:</div>
    </div>

    <div class="row justify-content-center mt-4">
      <table id="ltf-table">
        <colgroup>
          <col style="width: 30%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 20%;" />
        </colgroup>
        <thead>
          <tr>
            <th style="text-align: left;">Titre</th>
            <th>Poids (%)</th>
            <th>Scope 1 Tonnes Co2 / ans</th>
            <th>Scope 2 Tonnes Co2 / ans</th>
            <!--
            <th>
              <span v-b-modal="'my_modal_scoreEnt' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scoreEnt' + this.uid" centered hide-footer title="Chiffres d'affaires">
                <p class="my-4">
                  Le Scope 3 comprend toutes les autres émissions de gaz à effet de serre. Ces émissions ne sont pas directement liées à la fabrication du produit, mais sont liées à d'autres étapes du cycle de vie du produit (approvisionnement, transport, utilisation, fin de cycle de vie...cycle de vie...) . Par exemple, pour fabriquer un produit, vous avez besoin de matières premières. L'extraction, la transformation et le transport de ces matières premières vers les usines de production
                  émettent des gaz à effet de serre. De même, la fin de vie ou le recyclage du produit émettra également des gaz à effet de serre. Ces émissions indirectes liées au cycle de vie du produit sont enregistrées dans le Scope 3. On les appelle autres émissions indirectes.
                </p>
              </b-modal>
              Scope 3 Tonnes Co2 / ans</th>
            -->
            <th>
              <span v-b-modal="'my_score_co2_alt' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_score_co2_alt' + this.uid" centered hide-footer title="Score CO2 coût">
                <p class="my-4">
                  Ce score témoigne de l'impact de la position sur la planète. Son unité est la Tonne de Co2 / Milliards d'euros de chiffre d'affaire. Il correspond à la dépense énergétique de l'entreprise en fonction de son chiffre d'affaire (moyenne pondérée des entreprises dans le cas d'un fonds ou d'un ETF). Plus ce score est élevé plus la position a un impact négatif sur la planète en terme de rejet de C02. Ce score permet de comparer des entreprises de tailles différentes
                </p>
              </b-modal>
              Score Co2
            </th>
            <th>Chiffre d'affaires Tonnes Co2 / M€</th>
            <th>
              <span v-b-modal="'my_modal_scoreEn_alt' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scoreEn_alt' + this.uid" centered hide-footer title="Mon coût carbone">
                <p class="my-4">
                  Cet indicateur correspond au coût carbone réel de vos investissements. Il est calculé à partir de votre pourcentage de détention du capital des entreprises sur lesquels vous investissez. Par exemple si vous détenez 1% du capital d'une entreprise avec un coût carbone (scope 3) de 1 000 Tonnes de C02 par an, vous êtes alors responsable de la dépense énergétique de 10 Tonnes de C02 par an
                </p>
              </b-modal>
              Mon coût carbone</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(save, i) in comparison.alternative_esg" :key="i">
            <div v-if="save.hasOwnProperty('security')" style="display: contents;" id="random">
              <td style="text-align: left;">
                <div>{{ save.security.name }}</div>
                <div>ISIN : {{ save.security.isin }}</div>
              </td>
              <td>{{ Math.round(save.weight * 100) }}%</td>
              <td>
                {{ formatEuros(save.scope1) }}
              </td>
              <td>
                {{ formatEuros(save.scope2) }}
              </td>
              <!--
              <td>
                {{ formatEuros(save.scope3) }}
              </td>
              -->
              <td>
                {{ formatEuros(save.total) }}
              </td>
              <td>
                {{ formatEuros(Math.round(save.revenues)) }}
              </td>
              <td style="color:#9561E2">Coming Soon</td>
            </div>
          </tr>
          <tr>
            <div style="display: contents;" id="random">
              <td style="text-align: left;">
                Total
              </td>
              <td style="text-align: left;"></td>
              <td>{{ formatEuros(Math.round(comparison.alt_contract_esg_carbon_scope1)) }}</td>
              <td>{{ formatEuros(Math.round(comparison.alt_contract_esg_carbon_scope2)) }}</td>
              <!--<td>{{ formatEuros(Math.round(comparison.alt_contract_esg_carbon_scope3)) }}</td>-->
              <td>{{ formatEuros(Math.round(comparison.alt_contract_esg_carbon_overall)) }}</td>
              <td>{{ formatEuros(Math.round(comparison.alt_contract_esg_carbon_revenues)) }}</td>
              <td style="color:#9561E2">Coming Soon</td>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div class="row justify-content-center">
      <div class="col-md-4 element-x-ray m-2" style="border: 1px solid rgba(255, 255, 255, .12);">
        <table class="myfotable-dark">
          <colgroup>
            <col style="width: 12.5%;" />
            <col style="width: 12.5%;" />
            <col style="width: 12.5%;" />
            <col style="width: 12.5%;" />
            <col style="width: 12.5%;" />
            <col style="width: 12.5%;" />
            <col style="width: 12.5%;" />
          </colgroup>
          <thead>
            <tr>
              <th style="text-align: left;">Position</th>
              <th>Allocation</th>
              <th>Scope 1</th>
              <th>Scope 2</th>
              <th>Scope 3</th>
              <th>Chiffre d'affaires</th>
              <th>Mon coût carbone</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(save, i) in comparison.alternative_esg" :key="i">
              <div style="display: contents;" id="random">
                <td style="font-weight: bold; color: #635bff; text-align: left;">
                  {{ save.security.name }}
                </td>
                <td style="font-weight: bold; color: #635bff;">{{ Math.round(save.weight * 100) }} %</td>
                <td>
                  {{ save.scope1 }}
                </td>
                <td>
                  {{ save.scope2 }}
                </td>
                <td>
                  {{ save.scope3 }}
                </td>
                <td>
                  {{ save.revenues }}
                </td>
                <td>Coming Soon</td>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: ["comparisons", "comparisons_platforms", "accessgranted", "token", "route"],
  data() {
    return {
      save_portfolios: [],
      comparison: this.comparisons_platforms[0],
      comps_plats: this.comparisons_platforms[0],
      save_portfolio: [],
      access: "",
      show: false,
      variants: ["primary", "secondary", "success", "warning", "danger", "info", "light", "dark"],
      headerBgVariant: "info",
      headerTextVariant: "light",
      bodyBgVariant: "dark",
      bodyTextVariant: "dark",
      footerBgVariant: "info",
      footerTextVariant: "dark",
    };
  },

  mounted() {
    for (let key in this.comps_plats) {
      this.temp_array = [];
      this.temp_array.push(this.comps_plats[key]["portfolio_saved"]);
      this.temp_array.push(this.comps_plats[key]["platform_contract_id"]);
      this.save_portfolios.push(this.temp_array);
    }
    this.access = this.accessgranted;
  },

  methods: {
    modalId(i) {
      return "modal" + i;
    },
    formatEuros(number)
    {
      return this.$utils.numberWithSpaces(Number(number).toFixed(0));
    },
    filteredPlatformContract(comparison)
    {
      this.filters_save_portfolios = [];
      this.save_filter = [];
      if (comparison.platform_contract != null) {
        this.save_portfolios.forEach((save_portfolio) => {
          if (save_portfolio[1] === comparison[0].platform_contract.id) {
            this.filters_save_portfolios.push(save_portfolio[0]);
          }
        });
        return this.filters_save_portfolios[0];
      } else {
        return [];
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../../sass/_variables.scss";

#esgContainer {
  .esgCard {
    min-height: 150px;

    .first {
      text-align: center;
      font: normal normal normal $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      opacity: 1;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-evenly;
    }
    .nb {
      $mrg: 10px;
      text-align: center;
      font: normal normal bold $mf_ft_size_subtitle Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
      opacity: 1;
      margin-top: $mrg;
      margin-bottom: $mrg;
    }
    .last {
      text-align: center;
      font: normal normal normal $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      opacity: 1;
    }
  }
  #ltf-table {
    $thRadius: 20px;
    margin-top: 20px;
    margin-bottom: 0rem !important;

    .tbHeader {
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      .tbHeader_label {
        margin-right: 15px;
      }
    }

    .table thead th {
      vertical-align: bottom;
      border: none;
    }
    thead {
      background: transparent;
    }
    tbody {
      border-radius: 20px;
      background: #242527;
    }
    th {
      background-color: #242527;
      border-bottom: 2px solid black;
      color: #f5f5f5;
      text-align: center;
      padding: 15px;
    }
    th:first-child {
      border-top-left-radius: $thRadius;
    }

    th:last-child {
      border-top-right-radius: $thRadius;
    }

    tr {
      text-align: center;
      font: normal normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: #cacaca;
      opacity: 1;
    }
    tr:not(:first-child) {
      border-top: 2px solid black;
    }

    td {
      border: none;
      padding: 10px;
    }

    li > span {
      position: relative;
      display: block;
      padding: 0.5rem 0.75rem;
      margin-left: -1px;
      line-height: 1.25;
      color: black;
      background-color: transparent !important;
      border: none !important;
      cursor: pointer;
      font-size: 20px !important;
      font-weight: bold !important;
    }
  }
}
</style>
